module.exports = __webpack_public_path__ + "img/archive.c5ace621.svg";